import apiDriver from '@/api/logistic/driver';
import apiOption from '@/api/logistic/option';

const defaultState = () => ({
	listDriver: [],
	detailDriver: {},
	driverPagination: '',
	optionGender: [],
	responSukses: {},
	responseError: {},
	konfirmResponse: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {

	setDriver(state, data) {
		state.listDriver = data.data.map((el) => {
			if (el.driver_is_active == "active") {
				el.driver_is_active = true
			} else {
				el.driver_is_active = false
			}
			return el
		});
		// state.listDriver = data.data
		state.driverPagination = data.pagination;
	},
	setDetailDriver(state, data) {
		state.detailDriver = data
	},
	setOptionGender(state, data) {
		state.optionGender = data
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {}
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	validationError(state, data) {
		state.responseError = data
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
		state.alert = ''
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
};

const actions = {
	getDriver({ commit }, params) {
		apiDriver.getDriver(params).then(({ data: { data } }) => {
			commit('setDriver', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setDriver', { data: [], pagination: {} });
		});
	},
	getDetailDriver({ commit, dispatch }, params) {
		apiDriver.getDetailDriver(params).then(({ data: { data } }) => {
			commit('setDetailDriver', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailDriver', { data: [] });
		});
	},
	getOptionGender({ commit }){
		apiOption.getOptionGender().then( ({ data: { data } }) => {
			commit('setOptionGender', data.results);
		}).catch(() => {
			commit('setOptionGender', []);
		});
	},
	async add({ dispatch, commit }, value) {
		await dispatch('isAttempting', null, { root: true })
		commit("konfirmasiSukses", '');
		await apiDriver.addDriver(value).then( res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			commit("saveConfirmResponse", data);
			dispatch("errorHandler", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal tambah driver'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async update({ commit , dispatch}, value) {
		await dispatch('isAttempting', null, { root: true })
		await apiDriver.updateDriver(value).then(res => {
			const data = res.data;
			commit("konfirmasiSukses", data);
			dispatch('success', data)
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data);
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: "Gagal ubah data driver"
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async delete({ dispatch, commit }, value) {
		await apiDriver.deleteDriver({ id: value }).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus data driver'
			}, { root: true });
		});
	},
	async status({ dispatch, commit }, value) {
		await apiDriver.statusDriver(value).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah status driver'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};